import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
   encapsulation: ViewEncapsulation.None  // ✅ Make sure this line is here
})
export class TermsAndConditionsComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle('Terms and Conditions | MALtech');

    // Set meta description
    this.metaService.updateTag({
      name: 'description',
      content: 'MALtech reserves the right to monitor and remove any Comments which can be considered offensive or cause a breach of our Terms and Conditions.'
    });

    // Set meta keywords
    this.metaService.updateTag({
      name: 'keywords',
      content: 'terms, conditions, policy'
    });
  }

}
